/**
 * Which language the pay page speaks. The page has two, he_il and en_us; anything that is not
 * Hebrew is English.
 *
 * - A document request: the document's own language (jsond_doc.language), the language the
 *   merchant issued it in.
 * - An item link: the payer's browser. There is no document, and the link's language is the
 *   column default (he_il) whoever opens it.
 */
import { isItems } from './cart'

export const HEBREW = 'he_il'
export const ENGLISH = 'en_us'

/** he_il, he-IL, he, iw (old browsers' Hebrew) -> he_il; anything else, or nothing -> en_us. */
export function normalize(code) {
  const c = String(code || '').toLowerCase()
  return /^(he|iw)([-_]|$)/.test(c) ? HEBREW : ENGLISH
}

/** The browser's first choice. navigator.languages is the ordered list; language the old field. */
export function browserLanguage(nav) {
  const list = (nav && nav.languages && nav.languages.length) ? nav.languages : [nav && nav.language]
  return normalize(list[0])
}

/** The page language for a loaded row (/paymentreq/load). */
export function pageLanguage(data, nav) {
  if (isItems(data)) {
    return browserLanguage(nav)
  }
  return normalize(data && data.jsond_doc && data.jsond_doc.language)
}

export function direction(lang) {
  return lang === HEBREW ? 'rtl' : 'ltr'
}
